var map = {
	"./": 45771,
	"./assets/about-hero-image.png": 38863,
	"./assets/ecommerce.png": 30271,
	"./assets/education.png": 4545,
	"./assets/fintech.png": 18456,
	"./assets/healthcare.png": 81830,
	"./assets/local-business.png": 44683,
	"./assets/messaging.png": 60779,
	"./assets/publishing.png": 69508,
	"./assets/real-estate.png": 97302,
	"./assets/team1.jpg": 19819,
	"./assets/team2.jpg": 35164,
	"./assets/team3.jpg": 22041,
	"./assets/team4.jpg": 85322,
	"./assets/video_thumb.jpg": 49671,
	"./index": 45771,
	"./index.jsx": 45771,
	"./style.scss": 13256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39969;